import { StyleSheet } from 'aphrodite';
import { brandPrimary } from '../../styles/colors';

export const styleSheet = StyleSheet.create({
	flyoutBody: {
		flex: 1,
		minHeight: 0,
		overflowY: 'auto',
		padding: '12px 0',
	},
	subTitle: {
		color: brandPrimary,
		fontWeight: 600,
		margin: 0,
		marginBottom: 4,
	},
});
